import { NgModule } from '@angular/core';

import { BarcodeScannerPageModule } from 'pages/barcode-scanner-page/barcode-scanner-page.module';
import { LabelScannerPageModule } from 'pages/label-scanner-page/label-scanner-page.module';
import { MealPhotoScannerPageModule } from 'pages/meal-photo-scanner-page/meal-photo-scanner-page.module';
import { RecipeScannerPageModule } from 'pages/recipe-scanner-page/recipe-scanner-page.module';
import { EquipmentScannerPageModule } from 'pages/equipment-scanner-page/equipment-scanner-page.module';
import { WorkoutPlanScannerPageModule } from 'pages/workout-plan-scanner-page/workout-plan-scanner-page.module';

const SCANNER_PAGE_MODULES = [
  BarcodeScannerPageModule,
  LabelScannerPageModule,
  MealPhotoScannerPageModule,
  RecipeScannerPageModule,
  EquipmentScannerPageModule,
  WorkoutPlanScannerPageModule,
];

/**
 * The camera-scanning screens.
 *
 * One of the app's per-area page groups: it only groups page modules together,
 * declaring nothing of its own and adding no providers. Why these files exist and
 * what keeps them honest: `design-docs/angular-components.md`, "Creating New
 * Components", step 4.
 */
@NgModule({
  imports: SCANNER_PAGE_MODULES,
  exports: SCANNER_PAGE_MODULES,
})
export class ScannerPagesModule { }
